module.exports = __webpack_public_path__ + "static/media/unknown-phone.9ddc23b6.png";